var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartHopWalletLandingImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 326,
    viewBox: "0 0 455 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.418 209.632V304.653H240.785V326L262.95 304.653H314.543V209.632H182.418Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M214.643 209.632H182.418V247.546H214.643V209.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9624 0V235.716H143.059L165.224 257.063V235.716H203.417V0H49.9624Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.445 58.8282H203.374V191.758H364.445V58.8282Z",
    fill: "url(#paint0_linear_1_195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3575 189.597H0V274.906H85.3575V189.597Z",
    fill: "#FD6D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.822 189.597H85.3575V235.716H96.822V189.597Z",
    fill: "#FDB498"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M214.643 58.9808H203.374V191.911H214.643V58.9808Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6818 258.632C28.1268 258.632 16.2897 246.801 16.2897 232.255C16.2897 217.708 28.1268 205.877 42.6818 205.877C57.2369 205.877 69.074 217.708 69.074 232.255C69.074 246.801 57.2369 258.632 42.6818 258.632ZM42.6818 208.93C29.8125 208.93 19.3436 219.393 19.3436 232.255C19.3436 245.117 29.8125 255.58 42.6818 255.58C55.5511 255.58 66.02 245.117 66.02 232.255C66.02 219.393 55.5511 208.93 42.6818 208.93Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5409 230.728H17.8106V233.781H67.5409V230.728Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2088 232.255H41.1549V257.106H44.2088V232.255Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6818 239.842C46.8748 239.842 50.2739 236.445 50.2739 232.255C50.2739 228.064 46.8748 224.667 42.6818 224.667C38.4888 224.667 35.0897 228.064 35.0897 232.255C35.0897 236.445 38.4888 239.842 42.6818 239.842Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.762 53.6639H76.6111V101.352H176.762V53.6639Z",
    fill: "url(#paint1_linear_1_195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.121 129.023H76.6111V137.142H158.121V129.023Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.121 31.4133H76.6111V39.5322H158.121V31.4133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.181 145.651H76.6111V153.77H172.181V145.651Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.995 162.286H76.6111V170.405H144.995V162.286Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.072 250.495C270.072 238.579 260.403 228.915 248.481 228.915C236.558 228.915 226.889 238.579 226.889 250.495C226.889 255.476 228.581 260.06 231.421 263.711L231.464 263.759C231.586 263.918 231.708 264.077 231.83 264.229L248.481 285.363L265.546 263.711C268.38 260.06 270.078 255.476 270.078 250.495H270.072Z",
    fill: "#FD6D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.481 260.249C253.871 260.249 258.241 255.882 258.241 250.495C258.241 245.107 253.871 240.74 248.481 240.74C243.09 240.74 238.72 245.107 238.72 250.495C238.72 255.882 243.09 260.249 248.481 260.249Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.174 148.929C269.797 148.154 265.357 143.844 265.357 134.956H274.891C274.891 140.041 277.536 142.172 283.912 142.172C289.904 142.172 292.421 140.371 292.421 136.244C292.421 125.94 266.004 131.996 266.004 115.892C266.004 106.876 270.255 102.499 280.18 101.657V96.3093H287.656V101.657C297.582 102.493 301.833 106.742 301.833 115.63H292.298C292.298 110.606 289.788 108.482 283.925 108.482C278.385 108.482 276.064 110.221 276.064 114.409C276.064 123.041 302.48 117.498 302.48 134.761C302.48 143.844 298.034 148.221 287.663 148.996V154.277H280.187V148.929H280.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 155.699H329.782V235.716H355.771V254.835L375.622 235.716H455V155.699Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.049 181.374H347.734V188.962H437.049V181.374Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.594 181.374H347.734V188.962H409.594V181.374Z",
    fill: "#FD6D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.049 202.459H347.734V210.047H437.049V202.459Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.16 202.459H347.734V210.047H387.16V202.459Z",
    fill: "#FD6D35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_195",
    x1: 283.906,
    y1: 195.024,
    x2: 283.906,
    y2: 125.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6D35",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6D35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_195",
    x1: 126.69,
    y1: 101.358,
    x2: 126.69,
    y2: 53.6639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6D35",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6D35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 455,
    height: 326,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartHopWalletLandingImage);
export default __webpack_public_path__ + "static/media/smartHopWalletLandingImage.7cd49a91.svg";
export { ForwardRef as ReactComponent };